import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-squad-dialog-box',
  templateUrl: './squad-dialog-box.component.html',
  styleUrls: ['./squad-dialog-box.component.css']
})
export class SquadDialogBoxComponent implements OnInit {
  squadDetails: any;
  squadName;
  P1;
  P2;
  P3;
  list1 = [];
  list2 = [];
  list3 = [];
  initialListForUpdate = [];
  constructor(private authApi: AuthService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<SquadDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data.data) {
      const squadDetails = this.data.data;
      this.squadName = squadDetails.squadName;
      this.P1 = squadDetails.members[0].userName;
      this.P2 = squadDetails.members[1].userName;
      this.P3 = squadDetails.members[2].userName;
      this.list1.push(squadDetails.members[0]);
      this.list2.push(squadDetails.members[1]);
      this.list3.push(squadDetails.members[2]);
      this.initialListForUpdate.push(squadDetails.members[0]);
      this.initialListForUpdate.push(squadDetails.members[1]);
      this.initialListForUpdate.push(squadDetails.members[2]);
    }
  }
  onSubmit(form: NgForm) {
    var P1 = (this.list1.filter(x => x.userName === form.value.P1)[0])
    var P2 = (this.list2.filter(x => x.userName === form.value.P2)[0])
    var P3 = (this.list3.filter(x => x.userName === form.value.P3)[0])
    const obj = {
      squadName: form.value.squadName,
      participants: [
        {
          user_id: P1?._id,
          userName: P1?.userName
        },
        {
          user_id: P2?._id,
          userName: P2?.userName
        },
        {
          user_id: P3?._id,
          userName: P3?.userName
        }
      ]
    }
    if (this.data.data) {
      obj['_id'] = this.data.data._id;
      obj['oldList'] = this.initialListForUpdate;
      this.authApi.updateSquadDetails(JSON.parse(localStorage.getItem('eventDeatils'))._id, obj).subscribe((data) => {
        this.toastr.success("Squad Updated successfully", "Kudos Gammer");
        this.dialogRef.close()
      })
    } else {
      this.authApi.registerUserForsquadEvent(JSON.parse(localStorage.getItem('eventDeatils'))._id, obj).subscribe((data) => {
        this.toastr.success("User Registered successfully", "Kudos Gammer");
        this.dialogRef.close()

      })
    }
  }

  onSearchChange(value, number) {
    if (!value) return
    this.authApi.getSearchDetails(value).subscribe((details) => {
      switch (number) {
        case 1:
          this.list1 = details;
          break;
        case 2:
          this.list2 = details;
          break;
        case 3:
          this.list3 = details;
          break;
      }
    })

  }
}
